import { Container, Divider, Paper } from '@mui/material';

import { ContainerWrapper } from '../styledComponents';

export const Help = () => {
  return (
    <ContainerWrapper>
      <Container>
        <Paper className='paper' elevation={2}>
          <header>
            <h1>Help - User Guide</h1>
            <Divider />
          </header>
          <main>
            <section>
              <header>
                <h2>VERIFYING CANDIDATES</h2>
              </header>
              <p>
                For each candidate who has reported working at your company or
                associated company, an entry is included in the Rabbit portal
                that includes Given Name, Family Name, DOB, Tazkera, and SIV ID
                Number.
              </p>
              <p>
                For each candidate, you will begin by clicking the “
                <strong>Edit</strong>” button next to their name. This will take
                you to a page specifically about that one candidate.
              </p>
              <p>
                Once you are on a candidate’s page, you will be shown some
                reference information. This includes information that was
                supplied via the candidate’s SIV application, but it may contain
                errors, so keep that in mind. This area includes Reported
                Biographical Information for the candidate, as well as
                references to the work periods that they claimed to have worked.
                While it is very common for there to be errors in these
                sections, they will be helpful in helping you to identify the
                individual and their work history in your records. You will have
                a chance to enter the correct dates shortly.
              </p>
              <p>
                <b>Did the candidate work at your company?</b>
                <br /> First, it’s important to identify if they worked for your
                company or affiliated company at all. That’s where you’ll be
                presented with the question: “
                <strong>
                  Did this person work for your company on a DOW contract?
                </strong>
                ”
              </p>
              <p>
                <b>If they did not work at your company:</b>
                <br /> If you don’t believe they did, select “
                <strong>No</strong>”. At that point, you will be presented with
                another question.
                <br /> If you are certain they did not, you will enter “
                <strong>I'm certain they did not work for us</strong>”
                <br /> If you do not think they did but you are not certain
                because of a misspelling or other information that creates doubt
                for you, select “
                <strong>
                  There is insufficient information to confirm this case
                </strong>
                ”
                <br /> After you select an option here, click the “
                <strong>Submit</strong>” button. This will save that information
                and return you to the list of candidates.
              </p>
              <p>
                <b>If they did work at your company:</b>
                <br /> If they did work for your company or an affiliated
                entity, select “<strong>Yes</strong>”. At that point, you will
                be prompted to add and complete a “Work Period” entry for each
                work period they worked for your company (or affiliate).
              </p>
              <p>
                Typically, for each black box on the screen where it says “NOT
                EDITABLE — FOR REFERENCE ONLY”, you will need to add and
                complete a corresponding <strong>Work Period</strong>.
              </p>
            </section>
            <section>
              <header>
                <h2>ADDING A WORK PERIOD</h2>
              </header>
              <p>
                Begin by clicking the “<strong>ADD WORK PERIOD</strong>” button.
                This will bring up a form which you will fill out with all the
                details of a candidate’s information.
              </p>
              <p>
                Here you will input the candidate’s employment history. You’ll
                begin by including a DOW-affiliated contract number, and if
                relevant, any subcontract or CAGE numbers.
              </p>
              <p>
                You’ll also be asked to indicate the conditions of the End of
                Employment for the candidate. Select one of the options here to
                indicate why their employment ended.
              </p>
              <p>
                <b>Entering the reason for the end of employment:</b>
                <br /> In a few cases, for instance under “
                <strong>Resigned</strong>” or “
                <strong>Terminated For Cause</strong>” you’ll be asked to select
                a more specific reason from another menu that appears.
              </p>
              <p>
                If you don’t see a reason there that matches the information
                about the individual, you may select “
                <strong>Other Reason</strong>”, and you will be prompted to add
                a note there with the details on what that Other Reason is.
              </p>
              <p>
                <b>Adding notes:</b>
                <br /> Below that, there is an area for{' '}
                <strong>Additional Information</strong>. You can use this
                section to add anything else you think the Department of State
                should know about the candidate or their employment.
              </p>
              <p>
                That is the last part of the Work Period form. If you have
                entered all the relevant information here, then click on “
                <strong>Save Work Period</strong>”
              </p>
              <p>
                <b>Adding additional Work Periods:</b>
                <br /> If you have any additional Work Periods to add, click “
                <strong>ADD ADDITIONAL WORK PERIOD</strong>” and fill out the
                additional forms. This would be necessary for instance if there
                is more than one black box above in the reference section where
                it says “<strong>NOT EDITABLE — FOR REFERENCE ONLY</strong>”
                where your company or an affiliate is listed under{' '}
                <strong>Employer Name</strong>.
              </p>
              <p>
                Once you have completed all relevant work periods for a
                candidate, click the “<strong>Submit</strong>” button. After
                clicking Submit, you will be brought back to the main list of
                candidates and can then begin to verify the employment of
                another candidate.
              </p>
            </section>
            <section>
              <header>
                <h2>SIDEBAR DEFINITIONS</h2>
              </header>
              <p>
                <strong>Unchecked</strong> includes all the candidates we
                believe were employed by your company or an affiliate who you
                have not yet verified. This is the default view.
              </p>
              <p>
                <strong>In Progress</strong> includes candidates where you have
                started verifying their information, but have not yet Submitted
                them for any reason. This is included for your convenience so
                you don’t have to start over from a blank page in case you need
                to revisit a particular candidate.
              </p>
              <p>
                <strong>Did Not Work For Us</strong> includes the candidates who
                you were certain did not work for your company or associated
                company.
              </p>
              <p>
                <strong>Insufficient Data</strong> includes the candidates for
                whom you do not believe worked for your company or an affiliate
                but you want to do more research before saying no for sure.
              </p>
              <p>
                <strong>All Candidates</strong> includes all the candidates we
                believe were employed by your company or an affiliate. This
                includes all cases, whether or not you have reviewed them.
              </p>
              <p>
                <strong>Verified Employees</strong> includes all the candidates
                who you have confirmed worked for you for some period of time
              </p>
            </section>
          </main>
        </Paper>
      </Container>
    </ContainerWrapper>
  );
};
